import { useState, useContext } from "react";
import { CombinedContext } from "../../context/combinedContext";
import translations from "../../translations/translations";
import "./forgotPassword.css";
import usersRequest from "../../request/usersRequest";
import BannerMessage from "../common/bannerMessage/bannerMessage";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
	const { language } = useContext(CombinedContext);

	const [email, setEmail] = useState("");
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const [toast, setToast] = useState("");

	const navigate = useNavigate()

	async function handleSubmit(e) {
		e.preventDefault();
		if (!email) return;

		try {
			setLoading(true);
			setToast("");

			await usersRequest.forgotPassword(email);

			setSuccess(true);
			navigate("/confirmforgotpassword")
		} catch (err) {
			console.error(err);
			setToast(translations[language].forgotPassword.toast.error);
		} finally {
			setLoading(false);
		}
	}

	return (
		<div className="sf-auth-page">
			<div className="sf-auth-card">
				<h2>{translations[language].forgotPassword.title}</h2>

				{success ? (
					<p className="sf-auth-success">
						{translations[language].forgotPassword.success}
					</p>
				) : (
					<form onSubmit={handleSubmit}>
						<p className="sf-auth-sub">
							{translations[language].forgotPassword.subtitle}
						</p>

						<input
							type="email"
							className="sf-input"
							placeholder={translations[language].forgotPassword.email}
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							required
						/>

						<button
							type="submit"
							className="sf-btn sf-btn--brand"
							disabled={loading}
						>
							{loading
								? translations[language].forgotPassword.sending
								: translations[language].forgotPassword.send}
						</button>
					</form>
				)}

				{toast && <BannerMessage text={toast} />}
			</div>
		</div>
	);
};

export default ForgotPassword;
